import { render, staticRenderFns } from "./FlowDesigner.vue?vue&type=template&id=4afd127c&scoped=true"
import script from "./FlowDesigner.vue?vue&type=script&lang=js"
export * from "./FlowDesigner.vue?vue&type=script&lang=js"
import style0 from "./FlowDesigner.vue?vue&type=style&index=0&id=4afd127c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afd127c",
  null
  
)

export default component.exports